import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonGroup,
  Button,
  Heading,
  Input,
  Select,
  Text,
  Stack,
  TableContainer,
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  HStack,
  Modal,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CheckboxGroup,
  Checkbox,
  useToast,
  ModalOverlay,
  IconButton,
  Center,
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepIcon,
  StepNumber,
  StepTitle,
  StepDescription,
  StepSeparator,
  useBreakpointValue,
} from "@chakra-ui/react";

import { getHeadersForRequest, numberWithCommas } from "../utils/functions";
import axios from "axios";
import Cookies from "js-cookie";
import { ColorModeSwitcher } from "../components/ColorModeSwitcher";
import {
  CustomerList,
  PresetPrices,
  SaleListItem,
  SupplierList,
} from "../utils/types";
import {
  FlavourValues,
  PacketSizesValues,
  PricesValues,
  ProductsValues,
} from "../utils/strings";
import { getCustomerList, getSupplierList } from "../utils/API_calls";
import { FaAngleLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Loading } from "../components/Loading";
import useCustomTranslation from "../hooks/useCustomTranslation";
import { AddCustomer } from "../components/AddCustomer";
import AppContainer from "../components/AppContainer";
// import Nav from "../components/navbar";

const Form1 = () => {
  const [listItems, setListItems] = useState<SaleListItem[]>([]);
  const [price, setPrice] = useState<string>("");
  const [size, setSize] = useState<string>(PacketSizesValues[0]);
  const [product, setProduct] = useState<string>(ProductsValues[0]);
  const [flavour, setFlavour] = useState<string>(FlavourValues[0]);
  const [pktNum, setPacketNumber] = useState<string>("");
  const [invoiceDate, setInvoiceDate] = useState<Date>(new Date());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [customers, setCustomers] = useState<CustomerList[]>([]);
  const [modalIsLoading, setModalIsLoading] = useState<boolean>(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [prompt, setPrompt] = useState<boolean>(false);
  const [groupValues, setGroupValues] = useState<string[]>([]);
  const [deliveryNoteNumber, setDeliveryNoteNumber] = useState<string>("");
  const [receiptTotal, setReceiptTotal] = useState<number>(0);
  const [buyerIsSupplier, setBuyerIsSupplier] = useState<boolean>(false);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [suppliers, setSuppliers] = useState<SupplierList[]>([]);
  const [traReceiptNumber, setTraReceiptNumber] = useState<string>("");
  const [traReceiptTime, setTraReceiptTime] = useState<string>("");
  const [manualPrice, setManualPrice] = useState<boolean>(true);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<number>(0);
  const [addCustomer, setAddCustomer] = useState<boolean>(false);
  const [presetPrices, setPresetPrices] = useState<PresetPrices[]>([]);
  const [override, setOverride] = useState<boolean>(false);
  const [canOverride, setCanOverride] = useState<boolean>(true);
  const isSmallScreen = useBreakpointValue({ base: true, md: false });
  const [showRestoreDraftModal, setShowRestoreDraftModal] =
    useState<boolean>(false);
  const [draftToRestore, setDraftToRestore] = useState<any>(null);

  const { t, changeLanguage } = useCustomTranslation();

  const toast = useToast();

  const steps = [
    { title: "Customer", description: "Select Customer" },
    { title: "Invoice", description: "Add Invoice Items" },
    { title: "Info", description: "Additional Info" },
  ];
  const [indexState, setIndexState] = useState<number>(0);

  const handleRestoreDraft = () => {
    if (draftToRestore) {
      setListItems(draftToRestore.listItems || []);
      setPrice(draftToRestore.price || "");
      setSize(draftToRestore.size || PacketSizesValues[0]);
      setProduct(draftToRestore.product || ProductsValues[0]);
      setFlavour(draftToRestore.flavour || FlavourValues[0]);
      setPacketNumber(draftToRestore.pktNum || "");
      setInvoiceDate(
        draftToRestore.invoiceDate
          ? new Date(draftToRestore.invoiceDate)
          : new Date()
      );
      setSelectedCustomer(draftToRestore.selectedCustomer || "");
      setGroupValues(draftToRestore.groupValues || []);
      setDeliveryNoteNumber(draftToRestore.deliveryNoteNumber || "");
      setReceiptTotal(draftToRestore.receiptTotal || 0);
      setTraReceiptNumber(draftToRestore.traReceiptNumber || "");
      setTraReceiptTime(draftToRestore.traReceiptTime || "");
      setIndexState(draftToRestore.indexState || 0);

      // If a customer was selected, we might need to retrieve their preset prices again
      if (draftToRestore.selectedCustomer) {
        retrievePresetPrices(parseInt(draftToRestore.selectedCustomer));
      }
    }
    setShowRestoreDraftModal(false);
    setDraftToRestore(null);
  };

  const handleDiscardDraft = () => {
    localStorage.removeItem("salesOrderDraft");
    setShowRestoreDraftModal(false);
    setDraftToRestore(null);
  };

  useEffect(() => {
    const savedDraft = localStorage.getItem("salesOrderDraft");
    if (savedDraft) {
      try {
        const draft = JSON.parse(savedDraft);
        // Check if there's anything to restore
        if (
          (draft.listItems && draft.listItems.length > 0) ||
          draft.selectedCustomer
        ) {
          setDraftToRestore(draft);
          setShowRestoreDraftModal(true);
        }
      } catch (error) {
        console.error(
          "Error parsing sales order draft from localStorage",
          error
        );
        localStorage.removeItem("salesOrderDraft");
      }
    }
  }, []); // Empty dependency array means it runs once on mount

  useEffect(() => {
    const draft = {
      listItems,
      price,
      size,
      product,
      flavour,
      pktNum,
      invoiceDate,
      selectedCustomer,
      groupValues,
      deliveryNoteNumber,
      receiptTotal,
      traReceiptNumber,
      traReceiptTime,
      indexState,
    };
    localStorage.setItem("salesOrderDraft", JSON.stringify(draft));
  }, [
    listItems,
    price,
    size,
    product,
    flavour,
    pktNum,
    invoiceDate,
    selectedCustomer,
    groupValues,
    deliveryNoteNumber,
    receiptTotal,
    traReceiptNumber,
    traReceiptTime,
    indexState,
  ]);

  const findPresetPrice = (
    productVal: string,
    sizeVal: string,
    flavourVal?: string | null
  ) => {
    const norm = (s: string) => s.trim().toLowerCase();

    // exact match with flavour if available
    const exactWithFlavour = presetPrices
      .filter((p) => p.isVoid === false)
      .find((p) => {
        const pProd = norm(String((p as any).product ?? ""));
        const pSize = norm(String((p as any).size ?? ""));
        // const pFlv  = (p as any).flavour == null ? null : norm(String((p as any).flavour));
        return (
          pProd === norm(productVal) && pSize === norm(sizeVal)
          // pFlv != null &&
          // pFlv === (flavourVal ? norm(flavourVal)
          // : null)
        );
      });

    if (exactWithFlavour) return String((exactWithFlavour as any).price);

    // fallback: match only product + size
    const basicMatch = presetPrices
      .filter((p) => p.isVoid === false)
      .find((p) => {
        const pProd = norm(String((p as any).product ?? ""));
        const pSize = norm(String((p as any).size ?? ""));
        return pProd === norm(productVal) && pSize === norm(sizeVal);
      });

    if (basicMatch) return String((basicMatch as any).price);

    return null;
  };

  useEffect(() => {
    if (!product || !size || presetPrices.length === 0) return;

    const found = findPresetPrice(
      product,
      size,
      product.includes("Crisps") ||
        product.includes("Cashewnuts") ||
        product.includes("Sticks")
        ? flavour
        : undefined
    );

    console.log("found", found);
    console.log("price", price);

    if (found) {
      setManualPrice(false);
      setOverride(false);
      setPrice(found); // auto-fill
      // (optional) show a tiny toast once per change:
      toast({
        description: t("Applied preset price"),
        status: "info",
        duration: 2000,
        isClosable: true,
      });
    } else {
      setOverride(true);
      setManualPrice(true);
    }
  }, [product, size, flavour, presetPrices]); // keep `price` out to avoid loops

  const goToNextStep = () => {
    setIndexState((prev) => {
      const newIndex = prev < steps.length - 1 ? prev + 1 : prev;
      console.log("Next Step Index (before updating state):", newIndex);
      return newIndex;
    });
  };

  const goToPrevStep = () => {
    setIndexState((prev) => {
      const newIndex = prev > 0 ? prev - 1 : prev;
      console.log("Previous Step Index (before updating state):", newIndex);
      return newIndex;
    });
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInvoiceDate(e.target.valueAsDate || new Date());
  };

  const handleAddNewCustomer = () => {
    setAddCustomer(true);
  };

  const handleAddItem = () => {
    // console.log(price, size, product, packetNumber, flavour);
    if (
      price === "" ||
      size === "" ||
      parseInt(price) < 0 ||
      parseInt(size) <= 0 ||
      product === "" ||
      pktNum === "" ||
      parseInt(pktNum) <= 0 ||
      (product.includes("Crisps") && flavour === "")
    ) {
      toast({
        title: t("Please fill all fields"),
        status: "warning",
        duration: 9000,
        isClosable: true,
      });
      return;
    } else {
      let newItem: SaleListItem;
      let packetNumber = parseInt(pktNum);

      if (
        product.includes("Crisps") ||
        product.includes("Cashewnuts") ||
        product.includes("Sticks")
      ) {
        newItem = {
          id: Date.now(),
          price,
          size,
          product,
          packetNumber,
          flavour,
        };
      } else {
        newItem = {
          id: Date.now(),
          price,
          size,
          product,
          packetNumber,
          flavour: null,
        };
      }

      // Check if the combination of product, packet size, and flavour has been added before
      const isDuplicate = listItems.some(
        (item) =>
          item.product === product &&
          item.size === size &&
          item.flavour === flavour
      );

      if (isDuplicate) {
        toast({
          title: t("This combination already exists"),
          status: "warning",
          duration: 9000,
          isClosable: true,
        });
        return;
      }

      setListItems([...listItems, newItem]);
      toast({
        title: t("Added to the list!"),
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      if (!manualPrice) {
        setPrice("");
      }
      setPacketNumber("");
    }
  };

  const handleClearList = () => {
    setListItems([]);
    setIndexState(0);
    setSelectedCustomer("");
    localStorage.removeItem("salesOrderDraft");
  };

  const retrievePresetPrices = async (id: number) => {
    setModalIsLoading(true);
    console.log(id);
    try {
      const headers = await getHeadersForRequest();
      const response = await axios.post(
        `${process.env.REACT_APP_TEST_API_URL}/customers/getPresetPrices`,
        { id: id },
        { headers }
      );
      setPresetPrices(response.data.responseData);
      console.log(response);
      setModalIsLoading(false);
      goToNextStep();
    } catch (error) {
      console.error(error);
      setModalIsLoading(false);
    }
  };

  const retrieveCustomers = async () => {
    setModalIsLoading(true);
    const customers = await getCustomerList();
    if (customers.success === 1) {
      setCustomers(customers.data);
    } else {
      setCustomers([]);
    }
    setModalIsLoading(false);
  };

  const retrieveSuppliers = async () => {
    setModalIsLoading(true);
    const suppliers = await getSupplierList();
    if (suppliers.success === 1) {
      setSuppliers(suppliers.data);
    } else {
      setSuppliers([]);
    }
    setModalIsLoading(false);
  };

  const getTotal = () => {
    const receiptTotal = listItems.reduce((acc, item) => {
      const price = Number(item.price);
      const packetNumber = item.packetNumber;
      const itemTotal = price * packetNumber;
      return acc + itemTotal;
    }, 0);
    setReceiptTotal(receiptTotal);
  };

  const handleDeleteItem = (index: number) => {
    const newItems = [...listItems];
    newItems.splice(index, 1);
    setListItems(newItems);
    setShowConfirmationModal(false);
  };

  const handleSaveData = async () => {
    const email = Cookies.get("emailAddress");
    const data = {
      customerId: buyerIsSupplier
        ? null
        : selectedCustomer === ""
        ? null
        : selectedCustomer,
      supplierId: buyerIsSupplier ? selectedSupplier : null,
      paymentStatus: groupValues.includes("paid"),
      paymentDate: groupValues.includes("paid") ? new Date() : null,
      userId: email,
      deliveryStatus: groupValues.includes("delivered"),
      deliveryDate: groupValues.includes("delivered") ? new Date() : null,
      transactionDate: new Date(),
      physicalDeliveryNote: groupValues.includes("physical"),
      totalAmount: receiptTotal,
      items: listItems,
      invoiceDate: invoiceDate,
      transactionType: 1,
      deliveryNoteNumber: groupValues.includes("physical")
        ? deliveryNoteNumber
        : "",
      traReceiptNumber: traReceiptNumber,
      traReceiptTime: traReceiptTime,
    };

    if (data.supplierId === "") {
      toast({ description: t("Invalid Supplier") });
      return;
    }

    if (data.deliveryNoteNumber === "" && data.physicalDeliveryNote) {
      toast({ description: t("Invalid Delivery Note Number") });
      return;
    }

    setIsLoading(true);

    try {
      const headers = await getHeadersForRequest();

      const response = await axios.post(
        `${process.env.REACT_APP_TEST_API_URL}/transactions/save/sale`,
        data,
        { headers }
      );
      setIsLoading(false);
      setShowModal(false);
      handleClearList();
      toast({
        description: t("Transaction Details Saved!"),
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      localStorage.removeItem("salesOrderDraft");
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handlePromptClose = () => {
    setPrompt(false);
    setShowModal(false);
    retrieveCustomers();
    retrieveSuppliers();
    goToNextStep();
  };

  const handleInputChange = () => {
    setManualPrice(!manualPrice);
    setPrice("");
  };

  useEffect(() => {
    retrieveCustomers();
  }, []);

  return (
    <>
      <Modal
        isCentered
        isOpen={showRestoreDraftModal}
        onClose={handleDiscardDraft}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Restore Draft</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              Draft found, do you want to load it?
            </Text>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button variant="ghost" onClick={handleDiscardDraft}>
                No, Start New
              </Button>
              <Button colorScheme="blue" onClick={handleRestoreDraft}>
                Yes, Continue
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* <Heading w="100%" textAlign={"center"} fontWeight="normal" mb="2%">
        {t("New Invoice")}
      </Heading> */}

      {/* <br /> */}

      <Stepper size="lg" colorScheme="blue" index={indexState} mt="2%" mb="5%">
        {steps.map((step, index) => (
          <Step key={index}>
            <StepIndicator
              onClick={() => {
                if (index > indexState) {
                  toast({
                    description: "Can't do that",
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                  });
                } else {
                  setIndexState(index);
                }
              }}
            >
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={<StepNumber />}
              />
            </StepIndicator>

            {!isSmallScreen && (
              <Box flexShrink="0">
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </Box>
            )}

            <StepSeparator />
          </Step>
        ))}
      </Stepper>

      <br />

      {indexState === 0 && (
        <Stack pt={10}>
          <Text textAlign={"center"}>{t("PickCustomer")}</Text>

          <HStack justifyContent={"space-between"}>
            <Select
              flex={1}
              onChange={(e) => setSelectedCustomer(e.target.value)}
              value={selectedCustomer}
            >
              <option value={""}>{t("--Select Customer--")}</option>

              {customers
              .filter((customer) => customer.isVoid === false)
              .filter((customer) => customer.status === 1 || customer.status === 6)
              .map((customer) => (
                <option value={customer.id.toString()}>{customer.name}</option>
              ))}
            </Select>
            {!isSmallScreen && selectedCustomer === "" && (
              <Stack pl={1}>
                <Button
                  // bg={primary}
                  onClick={handleAddNewCustomer}
                >
                  Add
                </Button>
              </Stack>
            )}
          </HStack>

          {isSmallScreen && selectedCustomer === "" && (
            <Stack pt={10}>
              <Button
                // bg={primary}
                onClick={handleAddNewCustomer}
              >
                Add New
              </Button>
            </Stack>
          )}

          <Stack pt={10}>
            <Button
              // bg={primary}
              disabled={selectedCustomer === ""}
              onClick={() => retrievePresetPrices(parseInt(selectedCustomer))}
              isLoading={modalIsLoading}
            >
              Create Invoice
            </Button>
          </Stack>
        </Stack>
      )}

      {indexState === 1 && (
        <>
          <Stack alignItems={"center"} pb={10}>
            <HStack
              flexWrap={"wrap"}
              display={"flex"}
              justifyContent={"center"}
            >
              <Stack>
                <Text color="grey" fontSize="lg" fontFamily="">
                  {t("Product")}
                </Text>
                <Stack width={250}>
                  <Select
                    onChange={(e) => setProduct(e.target.value)}
                    borderWidth={3}
                  >
                    {ProductsValues.map((value) => (
                      <option value={value} key={value}>
                        {value.toString()}
                      </option>
                    ))}
                  </Select>
                </Stack>
              </Stack>
              <Stack>
                <Text color="grey" fontSize="lg" fontFamily="">
                  {t("PacketSize")}
                </Text>
                <Stack width={250}>
                  {Cookies.get("businessName") === "Keinth's Food" ? (
                    <Select
                      onChange={(e) => setSize(e.target.value)}
                      borderWidth={3}
                    >
                      {PacketSizesValues.map((value) => (
                        <option value={value} key={value}>
                          {value.toString() + " gms"}
                        </option>
                      ))}
                    </Select>
                  ) : (
                    <Input
                      borderWidth={3}
                      fontSize="md"
                      pl={5}
                      value={size}
                      backgroundColor="transparent"
                      variant={"underlined"}
                      onChange={(e) => setSize(e.target.value)}
                      placeholder={t("Enter qty in gms")}
                      inputMode="numeric"
                    />
                  )}
                </Stack>
              </Stack>
            </HStack>

            <HStack
              flexWrap={"wrap"}
              display={"flex"}
              justifyContent={"center"}
            >
              <Stack>
                <Text color="grey" fontSize="lg" fontFamily="">
                  {t("Flavour")}
                </Text>
                <Stack width={250}>
                  <Select
                    onChange={(e) => setFlavour(e.target.value)}
                    borderWidth={3}
                    isDisabled={
                      product.includes("Crisps") ||
                      product.includes("Cashewnuts") ||
                      product.includes("Sticks")
                        ? false
                        : true
                    }
                  >
                    {FlavourValues.map((value) => (
                      <option value={value} key={value}>
                        {value.toString()}
                      </option>
                    ))}
                  </Select>
                </Stack>
              </Stack>

              <Stack>
                <HStack alignItems={"center"} justifyContent={"space-between"}>
                  <Text color="grey" fontSize="lg" fontFamily="">
                    {t("Price")}
                  </Text>

                  <Button
                    variant={"ghost"}
                    size={"sm"}
                    disabled={!override}
                    onClick={() => {
                      handleInputChange();
                    }}
                  >
                    {manualPrice ? t("DropDown") : t("Manual")}
                  </Button>

                  {canOverride && (
                    <Button
                      colorScheme={!override ? "red" : "green"}
                      variant={"outline"}
                      size={"sm"}
                      onClick={() => {
                        setOverride(!override);
                      }}
                    >
                      {!override ? "Locked" : "Enabled"}
                    </Button>
                  )}
                </HStack>
                <Stack width={250}>
                  {manualPrice ? (
                    <Select
                      onChange={(e) => {
                        setPrice(e.target.value);
                      }}
                      borderWidth={3}
                    >
                      <option value={""} key={0}>
                        {"Select a price"}
                      </option>
                      {PricesValues.map((value) => (
                        <option value={value} key={value}>
                          {numberWithCommas(parseInt(value)) + "/="}
                        </option>
                      ))}
                    </Select>
                  ) : (
                    <Input
                      disabled={!override}
                      borderWidth={3}
                      fontSize="md"
                      pl={5}
                      value={price}
                      backgroundColor="transparent"
                      variant={"underlined"}
                      onChange={(e) => {
                        setPrice(e.target.value);
                      }}
                      placeholder={t("EnterPrice")}
                      inputMode="numeric"
                    />
                  )}
                </Stack>
              </Stack>
            </HStack>

            <Stack>
              <Text color="grey" fontSize="lg" fontFamily="">
                {t("NumberOfPackets")}
              </Text>

              <Stack width={250}>
                <Input
                  fontSize="md"
                  pl={5}
                  defaultValue={pktNum}
                  onChange={(e) => setPacketNumber(e.target.value)}
                  value={pktNum}
                  borderWidth={3}
                  inputMode="numeric"
                />
              </Stack>
            </Stack>
          </Stack>

          <Stack alignItems={"center"}>
            <Button
              variant={"solid"}
              onClick={handleAddItem}
              borderRadius={20}
              width={200}
              colorScheme="blue"
            >
              <Text>{t("Calculate")}</Text>
            </Button>
          </Stack>

          {listItems.length > 0 && (
            <Stack pt={10}>
              <TableContainer>
                <Table size="sm" variant="simple">
                  <TableCaption>
                    {" "}
                    {t("NumberOfItems")} {listItems.length}
                  </TableCaption>
                  <Thead>
                    <Tr>
                      <Th>{t("QTY")}</Th>
                      <Th>{t("DESCRIPTION")}</Th>
                      <Th isNumeric>{t("AMOUNT")}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {listItems.map((items, key) => (
                      <Tr
                        key={key}
                        onClick={() => {
                          setSelectedItem(key);
                          setShowConfirmationModal(true);
                        }}
                      >
                        <Td>{items.packetNumber}</Td>
                        <Td>
                          {items.product} - {items.flavour} {items.size}gms
                        </Td>
                        <Td isNumeric>
                          {numberWithCommas(
                            parseInt(items.price) * items.packetNumber
                          )}
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
              <Stack
                flex={1}
                flexDir={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                px={10}
                py={5}
              >
                <Button colorScheme="red" onClick={handleClearList}>
                  {t("CLEAR")}
                </Button>

                <Button
                  colorScheme="green"
                  onClick={() => {
                    setShowModal(true);
                    setPrompt(true);
                    getTotal();
                  }}
                >
                  {t("SAVE")}
                </Button>
              </Stack>
            </Stack>
          )}
        </>
      )}

      {indexState === 2 && (
        <Stack flex={1}>
          <Stack>
            {/* <Text fontWeight={"bold"}>Invoice Details:</Text> */}

            {isSmallScreen && (
              <>
                {/* <br /> */}

                <HStack>
                  <Text>Invoice Date: </Text>
                  <Stack>
                    <Input
                      flex={1}
                      // width={250}
                      placeholder="Invoice Date"
                      type="date"
                      value={invoiceDate.toISOString().substring(0, 10)}
                      onChange={handleDateChange}
                      variant={"filled"}
                    />
                  </Stack>
                </HStack>
              </>
            )}

            <HStack
              alignItems={"flex-start"}
              justifyContent={"space-between"}
              borderRadius={"5px"}
              borderWidth={"thin"}
              p={2}
            >
              {!isSmallScreen && (
                <Stack>
                  <Text>Invoice Date</Text>
                  <Stack>
                    <Input
                      flex={1}
                      width={250}
                      placeholder="Invoice Date"
                      type="date"
                      value={invoiceDate.toISOString().substring(0, 10)}
                      onChange={handleDateChange}
                      variant={"filled"}
                    />
                  </Stack>
                </Stack>
              )}

              <Stack alignItems={isSmallScreen ? "flex-start" : "flex-end"}>
                <HStack>
                  <Text>Customer: </Text>
                  <Text fontWeight={"bold"}>
                    {customers
                      .filter(
                        (customer) => customer.id === parseInt(selectedCustomer)
                      )
                      .map((customer) => customer.name)}
                  </Text>
                </HStack>

                <HStack>
                  <Text>TIN: </Text>
                  <Text fontWeight={"bold"}>
                    {customers
                      .filter(
                        (customer) => customer.id === parseInt(selectedCustomer)
                      )
                      .map(
                        (customer) =>
                          customer.tin &&
                          customer.tin.slice(0, 3) +
                            "-" +
                            customer.tin.slice(3, 6) +
                            "-" +
                            customer.tin.slice(6, 9)
                      )}
                  </Text>
                </HStack>

                <HStack>
                  <Text>Invoice Total: </Text>
                  <Text fontWeight={"bold"}>
                    {numberWithCommas(receiptTotal)}
                  </Text>
                </HStack>
              </Stack>
            </HStack>
          </Stack>

          <br />
          <Text fontWeight={"bold"}>Additional Invoice Details:</Text>
          <Stack borderRadius={"5px"} borderWidth={"thin"} p={2}>
            <Stack>
              <CheckboxGroup
                onChange={(values: string[]) => setGroupValues(values)}
                value={groupValues}
              >
                <Stack>
                  <Checkbox value="paid" my={2}>
                    {t("Paid")}
                  </Checkbox>
                  <Checkbox value="delivered" my={2}>
                    {t("Delivered")}
                  </Checkbox>
                </Stack>

                <Checkbox value="physical" isChecked my={2}>
                  {t("PhysicalDeliveryNote")}
                </Checkbox>

                {groupValues.includes("physical") && (
                  <Input
                    borderWidth={3}
                    fontSize="md"
                    pl={5}
                    backgroundColor="transparent"
                    variant={"underlined"}
                    inputMode="numeric"
                    onChange={(e) => setDeliveryNoteNumber(e.target.value)}
                    placeholder={t("deliverynotenumber")}
                  />
                )}

                <Checkbox value="tra" isChecked my={2}>
                  {t("TRAReceipt")}
                </Checkbox>
              </CheckboxGroup>
            </Stack>

            {/* <Stack>
              {groupValues.includes("physical") && (
                <Input
                  borderWidth={3}
                  fontSize="md"
                  pl={5}
                  backgroundColor="transparent"
                  variant={"underlined"}
                  inputMode="numeric"
                  onChange={(e) => setDeliveryNoteNumber(e.target.value)}
                  placeholder={t("deliverynotenumber")}
                />
              )}
            </Stack> */}

            <Stack>
              {groupValues.includes("tra") && (
                <>
                  <Input
                    borderWidth={3}
                    fontSize="md"
                    pl={5}
                    backgroundColor="transparent"
                    variant={"underlined"}
                    inputMode="numeric"
                    onChange={(e) => setTraReceiptNumber(e.target.value)}
                    placeholder={t("ReceiptNumber")}
                  />

                  <Input
                    borderWidth={3}
                    fontSize="md"
                    pl={5}
                    backgroundColor="transparent"
                    variant={"underlined"}
                    inputMode="numeric"
                    onChange={(e) => setTraReceiptTime(e.target.value)}
                    placeholder={t("ReceiptTime")}
                  />
                </>
              )}
            </Stack>
          </Stack>

          <Button
            mt={2}
            colorScheme="green"
            isLoading={isLoading}
            onClick={() => {
              handleSaveData();
            }}
          >
            Save
          </Button>
        </Stack>
      )}

      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(90deg)"
        />
        <ModalContent maxWidth="350">
          <ModalCloseButton />
          <ModalHeader>{t("DeleteItem")}</ModalHeader>
          <ModalBody>{t("ConfirmDeleteItem")}</ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onClick={() => {
                  setShowConfirmationModal(false);
                }}
              >
                {t("Cancel")}
              </Button>
              <Button
                colorScheme="red"
                isLoading={isLoading}
                onClick={() => {
                  handleDeleteItem(selectedItem);
                }}
              >
                {t("Delete")}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(90deg)"
        />
        <ModalContent maxWidth="350">
          <ModalCloseButton />
          <ModalHeader>{t("SaveOrder")}</ModalHeader>
          <ModalBody>
            {prompt && (
              <>
                <Text>
                  {t("YourTotalIs")} {numberWithCommas(receiptTotal)}/=
                </Text>
                <Text>{t("ConfirmSaveOrder")}</Text>
              </>
            )}
            {modalIsLoading && (
              <>
                <Center>
                  <Loading />
                </Center>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onClick={() => {
                  setShowModal(false);
                }}
              >
                {t("Cancel")}
              </Button>
              <Button
                isLoading={isLoading}
                onClick={() => {
                  handlePromptClose();
                }}
              >
                {t("SAVE")}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isCentered
        closeOnOverlayClick={false}
        onClose={() => {
          setAddCustomer(false);
          handlePromptClose();
        }}
        isOpen={addCustomer}
      >
        <ModalContent maxWidth="450">
          <ModalCloseButton />
          <ModalHeader>Add Customer</ModalHeader>
          <ModalBody>
            <AddCustomer isModal />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default function SalesOrder() {
  const navigate = useNavigate();
  return (
    <AppContainer pageName="New Invoice">
      <Center minH={"90dvh"}>
        <Box
          borderWidth="1px"
          rounded="lg"
          shadow="1px 1px 3px rgba(0,0,0,0.3)"
          p={6}
          maxW={"100%"}
          m="10px auto"
          as="form"
          minH="50dvh"
        >
          {/* <HStack justifyContent={"space-between"} alignItems={"baseline"}>
            <IconButton
              size="md"
              fontSize="lg"
              variant="ghost"
              color="current"
              marginLeft="2"
              onClick={() => navigate("/dashboard")}
              icon={<FaAngleLeft />}
              aria-label={`Go to home`}
            />

            <Stack alignItems={"flex-end"}>
              <ColorModeSwitcher mb={2} />
            </Stack>
          </HStack> */}

          <Form1 />
          {/* <MobileBottomSpacer height={64} gap={16} /> */}
        </Box>
      </Center>
      
      
    </AppContainer>
  )
}